import { lazyLabels } from "@/warRoom/lib/i18n";

/** enum 中文對照 — 取自 apps/server/src/db/schema/base/*.ts 的註解 */

export const PROJECT_STATUS = lazyLabels("warRoom.enums.projectStatus", [
  "normal",
  "close",
]);

export const PURCHASE_ORDER_STATUS = lazyLabels(
  "warRoom.enums.purchaseOrderStatus",
  ["draft", "underReview", "approved", "rejected", "completed"],
);

export const PAYMENT_METHOD = lazyLabels("warRoom.enums.paymentMethod", [
  "check",
  "transfer",
  "cash",
  "credit",
]);

export const DELIVERY_METHOD = lazyLabels("warRoom.enums.deliveryMethod", [
  "single",
  "partial",
]);

export const SHIPPING_FEE_CALCULATION = lazyLabels(
  "warRoom.enums.shippingFeeCalculation",
  ["freeShipping", "shippingFeeRequired"],
);

export const NODE_TYPE = lazyLabels("warRoom.enums.nodeType", [
  "building",
  "zone",
  "batch",
  "package",
]);

export const SCAN_MODE = lazyLabels("warRoom.enums.scanMode", [
  "multiple",
  "single",
  "all",
]);

/** employee.status —— apps/server/src/db/schema/base/employee.ts */
export const EMPLOYEE_STATUS = lazyLabels("warRoom.enums.employeeStatus", [
  "normal",
  "resigned",
]);

/** partner.status —— 停用要走審核，所以中間多一個 underReview */
export const PARTNER_STATUS = lazyLabels("warRoom.enums.partnerStatus", [
  "normal",
  "underReview",
  "disabled",
]);

/** stockReceipt／stockRequest 的 status 是 normal / done，不是停用 */
export const STOCK_DOC_STATUS = lazyLabels("warRoom.enums.stockDocStatus", [
  "normal",
  "done",
]);

export const ACCOUNT_KIND = lazyLabels("warRoom.enums.accountKind", [
  "AR",
  "AP",
]);

export const BOOL_LABEL = lazyLabels("warRoom.enums.bool", ["true", "false"]);
